<template>
  <div>
    <label :class="className" for="file-selector">
      <input id="file-selector" type="file" class="d-none" v-on:change="handleUpload" ref="file" :accept="accept" v-if="target && accept" />
      <input id="file-selector" type="file" class="d-none" v-on:change="handleUpload" ref="file" v-if="target && !accept" />
      {{ buttonTitle }}
    </label>
    <div class="progress" v-if="uploadPercentage">
      <div class="progress-bar" role="progressbar" :aria-valuenow="uploadPercentage" aria-valuemin="0" aria-valuemax="100" :style="'width: ' + uploadPercentage + '%'">
        <span class="sr-only">{{ this.uploadPercentage }} %</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import errors from '~/lib/errors'

export default {
  data () {
    return {
      file: '',
      uploadPercentage: 0
    }
  },
  mixins: [ errors ],
  props: ['target', 'title', 'accept', 'class'],
  computed: {
    buttonTitle () {
      return this.title ? this.title : this._('Upload file')
    },
    className () {
      return this.class ? this.class : 'btn btn-primary'
    }
  },
  methods: {
    async handleUpload () {
      this.file = this.$refs.file.files[0]
      let formData = new FormData()
      formData.append('file', this.file)
      let response
      try {
        response = await axios.post(this.target, formData, { 
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: event => {
            this.uploadPercentage = parseInt(Math.round(( event.loaded / event.total ) * 100, 10))
          }
        })
      } catch (e) {
        return this.showError(e)
      }
      this.$emit('done', response.data)
    }
  }
}

</script>

<style scoped>
.d-none {
  display: none !important;
}
</style>